import request from '@/utils/request'

const message = {
  name: 'message',
  state: {
    isMessageDetailLoading: false,
    messageDetailData: {}
  },

  mutations: {
    SET_IS_MODULES_MESSAGE_DETAIL_LOADING: (state, data) => {
      state.isMessageDetailLoading = data
    },
    SET_MODULES_MESSAGE_DETAIL_DATA: (state, data) => {
      state.messageDetailData = data
    }
  },

  actions: {
    //  获取账号编辑页面数据
    queryMessageDetailData({ commit }, id) {
      commit('SET_IS_MODULES_MESSAGE_DETAIL_LOADING', true)
      commit('SET_MODULES_MESSAGE_DETAIL_DATA', {})
      return new Promise((resolve, reject) => {
        request({
          url: '/modules/message/messageDetail',
          method: 'post',
          data: { id: id }
        }).then(response => {
          commit('SET_IS_MODULES_MESSAGE_DETAIL_LOADING', false)
          commit('SET_MODULES_MESSAGE_DETAIL_DATA', response.data)
          resolve(response.data)
        }).catch(error => {
          commit('SET_IS_MODULES_MESSAGE_DETAIL_LOADING', false)
          reject(error)
        })
      })
    },
    //  重置账号新增页面数据
    resetMessageDetailData({ commit }) {
      commit('SET_MODULES_MESSAGE_DETAIL_DATA', {
        type: 1
      })
    },
    setMessageDetailData({ commit }, data) {
      commit('SET_MODULES_MESSAGE_DETAIL_DATA', data)
    }
  }
}

export default message
